import { EGarageMaterial } from '../../../../api-models/common/json_query';

export const GARAGE_MATERIALS_MAP_VALUE_TO_LABEL = {
  [EGarageMaterial.Metal]: 'Металлический',
  [EGarageMaterial.Brick]: 'Кирпичный',
};
